// 온보딩 1회 노출 플래그 (Capacitor Preferences) — 가입/첫 로그인 직후 1회만 (감사 ④)
// 완성돼 있던 OnboardingScreen이 어떤 경로로도 호출되지 않던 고아 화면이라 신규유저가 못 보던 문제 배선.
// terra 버그10: 기기 단위 단일 키면 같은 기기의 신규 사용자가 온보딩을 건너뜀 → user.id 포함 키로 분리.
//   (기존 단일 키로 온보딩을 마친 계정은 1회 재노출 — 서버 프로필 이전은 과잉이라 최소 수정)
import { Preferences } from '@capacitor/preferences';

const KEY_BASE = 'sotda-onboarded';

// userId 없는 비정상 경로는 레거시 단일 키 폴백 (크래시·반복 노출 방지)
const keyFor = (userId: string | null | undefined) => (userId ? `${KEY_BASE}:${userId}` : KEY_BASE);

export async function isOnboarded(userId: string | null | undefined): Promise<boolean> {
  try {
    const { value } = await Preferences.get({ key: keyFor(userId) });
    return value === '1';
  } catch {
    return true; // 조회 실패 시 온보딩 반복 노출 방지(안전측 — 홈으로)
  }
}

export async function markOnboarded(userId: string | null | undefined): Promise<void> {
  try { await Preferences.set({ key: keyFor(userId), value: '1' }); } catch { /* ignore */ }
}
